import { VisuallyHidden } from '@zillow/constellation-10';

export function LoadPassiveAuth() {
  return (
    <VisuallyHidden>
      <form id="form">
        <input type="hidden" name="user_prefs" id="user_prefs" />
        <input type="hidden" name="user_prefs2" id="user_prefs2" />
      </form>
    </VisuallyHidden>
  );
}
